import type { ReactNode } from "react";

interface SectionProps {
  title: string;
  children: ReactNode;
}

export const Section = ({ title, children }: SectionProps) => (
  <section className="mt-10 space-y-4 text-[15px] text-foreground leading-relaxed">
    <h2 className="font-bold text-foreground text-xl sm:text-2xl">{title}</h2>
    {children}
  </section>
);

export const Subsection = ({ title, children }: SectionProps) => (
  <div className="mt-6 space-y-3">
    <h3 className="font-semibold text-foreground text-lg">{title}</h3>
    {children}
  </div>
);
